import { useId, useRef, useState } from 'react';
import { usePeriod } from '../context/PeriodContext';
import { formatPeriod } from '../format';
import { SmartSelect } from './Field';
import { useCerrarFuera } from './LocationPicker';

/**
 * «Este mes ▾» arriba a la derecha, junto a Ayuda (Alex, 12 oct 2026): sin
 * etiqueta «Periodo», sin las fechas escritas y sin botón «Cambiar fechas».
 * Este mes · Mes anterior · Últimos 3, 6 y 12 meses · Este año · Elegir
 * fechas… («Elegir fechas…» abre el calendario).
 */
export function PeriodPicker(): JSX.Element {
  const { period, setPeriod, presets } = usePeriod();
  const selectId = useId();
  const desdeId = useId();
  const hastaId = useId();
  const [calendario, setCalendario] = useState(false);
  const caja = useRef<HTMLDivElement>(null);
  useCerrarFuera(caja, calendario, () => setCalendario(false));

  const activo = presets.find((p) => p.period.start === period.start && p.period.end === period.end)?.id ?? 'rango';

  return (
    <div className="filtro-cabecera period" ref={caja}>
      <label className="sr-only" htmlFor={selectId}>Periodo</label>
      <SmartSelect
        id={selectId}
        className="filtro-cabecera__select"
        buscable={false}
        value={activo}
        onChange={(valor) => {
          const preset = presets.find((p) => p.id === valor);
          if (preset) {
            setPeriod(preset.period);
            setCalendario(false);
          } else if (valor === 'elegir') {
            setCalendario(true);
          }
        }}
        options={[
          ...presets.map((preset) => ({ value: preset.id, label: preset.label })),
          // El rango elegido a mano se ve como una opción más; «Elegir fechas…» lo vuelve a abrir.
          ...(activo === 'rango' ? [{ value: 'rango', label: formatPeriod(period.start, period.end) }] : []),
          { value: 'elegir', label: 'Elegir fechas…' },
        ]}
      />
      {calendario && (
        <div className="filtro-cabecera__menu filtro-cabecera__menu--fechas" role="group" aria-label="Elegir fechas">
          <label className="filtro-cabecera__fecha" htmlFor={desdeId}>
            Desde
            <input
              id={desdeId}
              type="date"
              className="input input--compact"
              value={period.start}
              max={period.end}
              onChange={(event) => setPeriod({ ...period, start: event.target.value || period.start })}
            />
          </label>
          <label className="filtro-cabecera__fecha" htmlFor={hastaId}>
            Hasta
            <input
              id={hastaId}
              type="date"
              className="input input--compact"
              value={period.end}
              min={period.start}
              onChange={(event) => setPeriod({ ...period, end: event.target.value || period.end })}
            />
          </label>
          <button type="button" className="btn btn--sm" onClick={() => setCalendario(false)}>Listo</button>
        </div>
      )}
    </div>
  );
}
